import { c as _c } from "react/compiler-runtime";
export default function WegrowEcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M78.9 65.98h-8.86V22.1a1 1 0 00-1-1H61a1 1 0 00-1 1v43.88h-6.92V37.52a1 1 0 00-1-1h-8.04a1 1 0 00-1 1v28.46h-6.91V28.13a1 1 0 00-1-1h-8.04a1 1 0 00-1 1v37.85h-6.92V39.9a1 1 0 00-1-1h-8.04a1 1 0 00-1 1v26.08H2.1V19.282l11.719 4.121a1.001 1.001 0 00.901-.122L31.164 11.87l16.404 9.271a1 1 0 001.186-.15L67.03 3.381 67 10.275a1 1 0 00.996 1.004H68a1 1 0 001-.995l.04-9.25c0-.016-.009-.031-.01-.047a.989.989 0 00-.27-.661.988.988 0 00-.752-.296L58.78.02a1 1 0 10-.002 2l6.774.007-17.65 17.006-16.3-9.214a1.002 1.002 0 00-1.063.049L14 21.347 2.1 17.162V1.02a1 1 0 10-2 0v65.96a1 1 0 001 1h77.8a1 1 0 100-2zM45.04 38.52h6.04v27.45h-6.04V38.52zM11.13 40.9h6.04v25.07h-6.04V40.9zm16.96 25.08V29.13h6.04v36.85h-6.04zm33.91 0V23.1h6.04v42.88H62z" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg className={className} fill="currentColor" viewBox="0 0 80 68" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}